// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Bf7a","list":"PatternAutocomplete_list__3CvXg"};